import { render, staticRenderFns } from "./CustomUpdateDialog.vue?vue&type=template&id=8fdf2634&scoped=true"
import script from "./CustomUpdateDialog.vue?vue&type=script&lang=js"
export * from "./CustomUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomUpdateDialog.vue?vue&type=style&index=0&id=8fdf2634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdf2634",
  null
  
)

export default component.exports